import { render, staticRenderFns } from "./EmptyMailbox.vue?vue&type=template&id=121b71b0"
import script from "./EmptyMailbox.vue?vue&type=script&lang=js"
export * from "./EmptyMailbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports